import React from 'react';
import PropTypes from 'prop-types';
import SourceSkeletonCardMinimal from '../../sources/card/source_skeleton_card_minimal';

function CompanyExpertsSkeletonPage({ numberOfCards }) {
  return (
    <>
      {Array(numberOfCards)
        .fill()
        .map((item, index) => (
          <div className="col mb-3" key={index} style={{ marginTop: '4rem' }}>
            <SourceSkeletonCardMinimal />
          </div>
        ))}
    </>
  );
}

CompanyExpertsSkeletonPage.propTypes = {
  numberOfCards: PropTypes.number.isRequired,
};

export default CompanyExpertsSkeletonPage;
